import { render } from "./habitaciones.vue?vue&type=template&id=e9c12136&scoped=true"
import script from "./habitaciones.vue?vue&type=script&lang=js"
export * from "./habitaciones.vue?vue&type=script&lang=js"

import "./habitaciones.vue?vue&type=style&index=0&id=e9c12136&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e9c12136"]])

export default __exports__